// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/statusOsService.ts
//  Cadastro de Status da Ordem de Serviço.
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  StatusOrdemServico,
  StatusOrdemServicoCombo,
  SalvarStatusOrdemServicoRequest,
} from '../types';

const BASE = '/api/status-os';

export const statusOsService = {
  async getAll(): Promise<StatusOrdemServico[]> {
    const { data } = await apiClient.get<StatusOrdemServico[]>(BASE);
    return data;
  },

  async getCombo(): Promise<StatusOrdemServicoCombo[]> {
    const { data } = await apiClient.get<StatusOrdemServicoCombo[]>(`${BASE}/combo`);
    return data;
  },

  async create(req: SalvarStatusOrdemServicoRequest): Promise<StatusOrdemServico> {
    const { data } = await apiClient.post<StatusOrdemServico>(BASE, req);
    return data;
  },

  async update(id: number, req: SalvarStatusOrdemServicoRequest): Promise<StatusOrdemServico> {
    const { data } = await apiClient.put<StatusOrdemServico>(`${BASE}/${id}`, req);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
